import { useNotificationsStore } from '@/stores/notifications/notifications.store';

export default function importContact(): void {
  const notificationsStore = useNotificationsStore();

  notificationsStore.increaseNotificationsNumber();
}
